var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "progress-bar" }, [
    _c("div", { staticClass: "progress-bar__value" }, [
      _vm._v("\n        " + _vm._s(_vm.progress) + "%\n    ")
    ]),
    _c("div", { staticClass: "progress-bar__progress-container" }, [
      _c("div", {
        staticClass: "progress-bar__progress",
        style: { width: _vm.progress + "%" }
      })
    ]),
    _c("div", { staticClass: "progress-bar__text" }, [
      _vm._v("\n        " + _vm._s(_vm.message) + "\n    ")
    ]),
    _vm.allowCancel
      ? _c(
          "div",
          { staticClass: "progress-bar__cancel" },
          [
            _c(
              "base-button",
              {
                attrs: { id: "cancelAction", primary: "" },
                on: {
                  click: function($event) {
                    return _vm.$emit("cancel")
                  }
                }
              },
              [_vm._v("\n            " + _vm._s(_vm.cancelText) + "\n        ")]
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }